import { Link, NavLink, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/events", label: "Events" },
  { to: "/past-events", label: "Past Events" },
  { to: "/gallery", label: "Gallery" },
  { to: "/founders", label: "Founders" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
  { to: "/download-ticket", label: "My Tickets" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;

  return (
    <nav className="sticky top-0 z-50 border-b border-[#D4AF37]/20 bg-[#0A0A0C]/90 backdrop-blur-md" data-testid="main-navbar">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex flex-col leading-none" data-testid="nav-logo">
            <span className="font-serif text-lg font-bold tracking-wide gold-text sm:text-xl">SIRAKH CREATIONS</span>
            <span className="text-[9px] tracking-[0.25em] text-zinc-500">MUSIC • PEOPLE • MOMENTS</span>
          </Link>

          <div className="hidden items-center gap-7 lg:flex">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/"}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors ${isActive ? "text-[#E5C158]" : "text-zinc-300 hover:text-[#E5C158]"}`}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
                {l.label}
              </NavLink>
            ))}
            <Link to="/events" className="btn-gold !px-5 !py-2.5 text-sm" data-testid="nav-book-tickets">BOOK TICKETS</Link>
          </div>

          <button className="text-[#E5C158] lg:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-[#D4AF37]/15 bg-[#0A0A0C] px-4 py-4 lg:hidden" data-testid="mobile-menu">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/"} onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-base font-medium ${isActive ? "bg-[#D4AF37]/10 text-[#E5C158]" : "text-zinc-200"}`}>
                {l.label}
              </NavLink>
            ))}
            <Link to="/events" onClick={() => setOpen(false)} className="btn-gold mt-3 w-full" data-testid="mobile-book-tickets">BOOK TICKETS</Link>
          </div>
        </div>
      )}
    </nav>
  );
};
